import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块,post数据需要qs格式化
import base from './base'// 导入接口域名列表

//系统管理相关接口
const myAllWork={
  //检查是否授权成功
  getTitle(params){
    return axios.get(`${base.bs}/guest/login/getTitle`,null);
  },
  //获取logo
  getLogo(params){
    // console.log("----我使用新的了-----"+params)
    return axios.get(`${base.bs}/getLogo/${params.hostname}`,null);
  },
//登录 卡号密码
  login(params){
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/guest/login/sign`,params);
  },
  //登录 授权
  sqlogin(params){
    // console.log("----我使用新的了-----"+params)
    return axios.get(`${base.bs}/guest/login/sqsign/${params.uuid}`,null);
  },
  //登录授权二维码
  sqQrcode(params){
    // console.log("----我使用新的了-----"+params)
    return axios.get(`${base.bs}/guest/login/getQrcode`,params);
  },
  //检查是否授权成功
  isLogin(params){
    return axios.get(`${base.bs}/guest/login/isLogin/${params.uuid}`,null);
  },
  //左侧菜单列表
  leftMenus(params){
    return axios.get(`${base.bs}/guest/menus/leftMenus`,{params:params})
  },

}
// 导出接口
export  default myAllWork;



// WEBPACK FOOTER //
// ./src/request/api/sys.js